export class SearchResultItem {

  public id : number;
  public type: string;
  public title : string;
  public text : string;

  constructor(id: number, type: string, title: string, text : string) {
    this.id = id;
    this.type = type;
    this.title = title;
    this.text = text;
  }

}
